import { render, staticRenderFns } from "./Bar.vue?vue&type=template&id=052f434e"
import script from "./Bar.vue?vue&type=script&lang=js"
export * from "./Bar.vue?vue&type=script&lang=js"
import style0 from "./Bar.vue?vue&type=style&index=0&id=052f434e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports